import { ThumbUpOutlined } from "@material-ui/icons";
import firebase from "firebase/compat";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { BACKGROUND_COLOR, GRAY_DARK } from "../../../constants/enums";
import {
  CardSchema,
  FirestoreCollection,
  UserNotificationItemSchema
} from "../../../constants/firestore_schema";
import {
  addToCardIdStackUrl,
  parseDoc,
  truncateLongSentence
} from "../../../utils/utils";
import UserName from "../../profile/OXOUserProfile/UserName";

const MAX_COMMENT_CUTOFF = 20;

export default function PostLikeNotification({
  userNotification
}: {
  userNotification: UserNotificationItemSchema;
}) {
  const history = useHistory();
  const location = useLocation();
  const [post, setPost] = useState<CardSchema>();

  useEffect(() => {
    if (
      userNotification.postLikeUserNotification &&
      userNotification.postLikeUserNotification.postId
    ) {
      firebase
        .firestore()
        .collection(FirestoreCollection.CARDS)
        .doc(userNotification.postLikeUserNotification.postId)
        .get()
        .then(snapshot => {
          setPost(parseDoc(snapshot));
        });
    }
  }, [userNotification.postLikeUserNotification]);

  if (!post) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        padding: "20px 20px 20px 10px",
        borderBottom: "1px solid " + BACKGROUND_COLOR
      }}
    >
      <div
        style={{
          color: GRAY_DARK,
          minWidth: "60px",
          padding: "3px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          verticalAlign: "baseline"
        }}
      >
        <div>
          <ThumbUpOutlined
            style={{
              color: GRAY_DARK,
              fontWeight: "bold"
            }}
          />
          <span
            style={{
              fontSize: "12px",
              marginLeft: "2px",
              verticalAlign: "sub"
            }}
          >
            {userNotification.postLikeUserNotification?.likes}
          </span>
        </div>
      </div>

      <div
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (userNotification.postLikeUserNotification) {
            history.push(
              history.location.pathname +
                addToCardIdStackUrl(
                  history.location.search,
                  userNotification.postLikeUserNotification.likeUserId
                )
            );
          }
        }}
      >
        {userNotification.postLikeUserNotification && (
          <span
            style={{ cursor: "pointer", fontWeight: "bold" }}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <UserName
              profileUserId={
                userNotification.postLikeUserNotification.likeUserId
              }
            />
          </span>
        )}
        님이{" "}
        {post
          ? '"' + truncateLongSentence(post.title, MAX_COMMENT_CUTOFF) + '"'
          : "삭제된 "}{" "}
        생각을 공감했습니다.
        <div
          style={{
            fontSize: "14px",
            color: GRAY_DARK
          }}
        >
          {new Date(userNotification.createdAt).toLocaleDateString() +
            " " +
            new Date(userNotification.createdAt).toLocaleTimeString()}
        </div>
      </div>
    </div>
  );
}
